import { Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core'

@Directive({
    selector: '[appEditableIcon]',
})
export class EditableIconDirective implements OnInit, OnDestroy {

    @Input() alwaysShowEditableIcon = false
    @Input() light = false

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {
        if (!this.alwaysShowEditableIcon) {
            return
        }
        const img = this.renderer.createElement('img')
        const src = this.light ? '/assets/edit/normal_white.svg' : '/assets/edit/normal.svg'
        this.renderer.setAttribute(img, 'src', src)
        this.renderer.setAttribute(img, 'alt', 'Edit')
        // set width and height attributes to 16px
        this.renderer.setAttribute(img, 'width', '16')
        this.renderer.setAttribute(img, 'height', '16')
        this.renderer.appendChild(this.el.nativeElement, img)
    }
    
    ngOnDestroy() {
        const img = this.el.nativeElement.querySelector('img')
        if (img) {
            this.renderer.removeChild(this.el.nativeElement, img)
        }
    }

    @HostListener('mouseenter') onMouseEnter() {
        if (this.alwaysShowEditableIcon) {
            return
        }
        const img = this.renderer.createElement('img')
        const src = this.light ? '/assets/edit/normal_white.svg' : '/assets/edit/normal.svg'
        this.renderer.setAttribute(img, 'src', src)
        this.renderer.setAttribute(img, 'width', '16')
        this.renderer.setAttribute(img, 'height', '16')
        this.renderer.setAttribute(img, 'alt', 'Edit')
        this.renderer.appendChild(this.el.nativeElement, img)
    }

    @HostListener('mouseleave') onMouseLeave() {
        if (this.alwaysShowEditableIcon) {
            return
        }
        const img = this.el.nativeElement.querySelector('img')
        if (img) {
            this.renderer.removeChild(this.el.nativeElement, img)
        }
    }
}
